/**
 * Bluey's Corner — shared cart + wishlist behavior for bc-* sections.
 * Vanilla JS, no frameworks.
 *
 * Keeps the Horizon cart hooks intact:
 *  - after a successful add we dispatch `cart:update` with detail.data.itemCount
 *    so the <cart-icon> component (cart-icon.js) updates the badge instantly;
 *  - we spawn the same <fly-to-cart> element Horizon uses, targeting the
 *    `.header-actions__cart-icon` destination in the header.
 */
(function () {
  if (window.BCCartInit) return;
  window.BCCartInit = true;

  var routes = (window.Theme && window.Theme.routes) || {};
  var addUrl = routes.cart_add_url || '/cart/add.js';
  var cartUrl = '/cart.js';

  function dispatchCartUpdate(itemCount, cart) {
    var event = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || null,
        sourceId: 'bc-section',
        data: { itemCount: itemCount, source: 'bc-section' },
      },
    });
    document.dispatchEvent(event);
  }

  function openCartDrawer(cart) {
    document.dispatchEvent(new CustomEvent('bc-cart:open', {
      bubbles: true,
      detail: { cart: cart || null },
    }));
  }

  function flyToCart(sourceEl, image) {
    var destination = document.querySelector('.header-actions__cart-icon');
    if (!destination || !sourceEl || !image) return;

    var spawn = function () {
      var el = document.createElement('fly-to-cart');
      el.classList.add('fly-to-cart--main');
      el.style.setProperty('background-image', 'url(' + image + ')');
      el.style.setProperty('--start-opacity', '0');
      el.source = sourceEl;
      el.destination = destination;
      document.body.appendChild(el);
    };

    if (window.customElements && customElements.get('fly-to-cart')) {
      spawn();
      return;
    }

    try {
      import('@theme/fly-to-cart').then(spawn).catch(function () {});
    } catch (e) {
      /* fly animation is progressive enhancement only */
    }
  }

  function setAdded(button) {
    if (!button) return;
    button.setAttribute('data-added', 'true');
    window.setTimeout(function () {
      button.removeAttribute('data-added');
    }, 1400);
  }

  function showError(form, message) {
    var error = form.querySelector('.bc-form-error');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    window.setTimeout(function () {
      error.hidden = true;
    }, 6000);
  }

  /* Capture phase is required: Shopify's shop_events_listener binds its own
     submit handler on the form element itself and publishes a duplicate
     product_added_to_cart (double Meta AddToCart) unless defaultPrevented is
     already set by the time that handler runs. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('bc-add-form')) return;

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button && button.disabled) return;
    if (button) button.disabled = true;

    var formData = new FormData(form);

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (result) {
        if (result.status) {
          showError(form, result.description || result.message || 'Something went wrong.');
          return null;
        }
        return fetch(cartUrl).then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        if (!cart) return;
        dispatchCartUpdate(cart.item_count, cart);
        openCartDrawer(cart);
        setAdded(button);
        flyToCart(button, form.getAttribute('data-product-image') || '');
      })
      .catch(function () {
        showError(form, 'Something went wrong. Please try again.');
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }, true);

  /* Wishlist hearts: visual toggle persisted locally. */
  var WISHLIST_KEY = 'bc-wishlist';

  function readWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    } catch (e) {
      /* private mode */
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target.closest('.bc-product-card__wishlist') : null;
    if (!target) return;

    event.preventDefault();
    var handle = target.getAttribute('data-handle');
    var pressed = target.getAttribute('aria-pressed') === 'true';
    target.setAttribute('aria-pressed', pressed ? 'false' : 'true');

    if (!handle) return;
    var items = readWishlist();
    if (pressed) {
      items = items.filter(function (item) {
        return item !== handle;
      });
    } else if (items.indexOf(handle) === -1) {
      items.push(handle);
    }
    writeWishlist(items);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var items = readWishlist();
    if (!items.length) return;
    document.querySelectorAll('.bc-product-card__wishlist[data-handle]').forEach(function (button) {
      if (items.indexOf(button.getAttribute('data-handle')) !== -1) {
        button.setAttribute('aria-pressed', 'true');
      }
    });
  });
})();
